export function normalizePathname(pathname: string): string {
	const path = (pathname.split('?')[0]?.split('#')[0] ?? '').toLowerCase();
	return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

export function matchesRouteSegment(path: string, route: string): boolean {
	return path === route || path.startsWith(`${route}/`);
}
